import { render, staticRenderFns } from "./payTotal.vue?vue&type=template&id=472d7f2f&scoped=true&"
import script from "./payTotal.vue?vue&type=script&lang=js&"
export * from "./payTotal.vue?vue&type=script&lang=js&"
import style0 from "./payTotal.vue?vue&type=style&index=0&id=472d7f2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d7f2f",
  null
  
)

export default component.exports